import { jsxs as h, Fragment as $, jsx as e } from "react/jsx-runtime";
import { useMemo as C } from "react";
import t from "./style.module.less.js";
import s from "./arrow-right.svg.js";
var v = /* @__PURE__ */ ((n) => (n.BLUE_INVERSE = "blue-inverse", n.BLUE = "blue", n.BLUE_MIDNIGHT = "blue-midnight", n.PURPLE = "purple", n.CUSTOM = "custom", n))(v || {});
const x = (n) => {
  const {
    text: m,
    classNames: r,
    disabled: o,
    icon: i,
    iconOnHover: u,
    target: w,
    buttonType: a = "blue"
    /* BLUE */
  } = n, c = n.link, l = n.onClick, b = /* @__PURE__ */ h($, { children: [
    /* @__PURE__ */ e("div", { className: `${t.buttonText} ${(r == null ? void 0 : r.buttonText) ?? ""}`, children: m }),
    /* @__PURE__ */ h("div", { className: `${t.buttonArrow} ${(r == null ? void 0 : r.buttonArrow) ?? ""}`, children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: `${t.arrowIconWrapperHover} ${(r == null ? void 0 : r.buttonArrowIcon) ?? ""}`,
          children: u ? /* @__PURE__ */ e(
            "img",
            {
              src: u,
              alt: "arrow-right-white",
              className: t.arrowIcon,
              width: 16,
              height: 16
            }
          ) : /* @__PURE__ */ e(s, { className: `${t.arrowIcon} ${t.onHover}` })
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: `${t.arrowIconWrapper} ${(r == null ? void 0 : r.buttonArrowIcon) ?? ""}`,
          children: i ? /* @__PURE__ */ e(
            "img",
            {
              src: i,
              alt: "arrow-right",
              className: t.arrowIcon,
              width: 16,
              height: 16
            }
          ) : /* @__PURE__ */ e(s, { className: t.arrowIcon })
        }
      )
    ] })
  ] }), d = C(() => {
    switch (a) {
      case "blue-inverse":
        return t.buttonContainerBlueInverse;
      case "blue":
        return t.buttonContainerBlue;
      case "blue-midnight":
        return t.buttonContainerBlueMidnight;
      case "purple":
        return t.buttonContainerPurple;
      case "custom":
        return t.buttonContainerCustom;
      default:
        return "";
    }
  }, [a]);
  if (c)
    return /* @__PURE__ */ e(
      "a",
      {
        href: c,
        className: `${t.buttonContainer} ${d} ${(r == null ? void 0 : r.buttonContainer) ?? ""}`,
        "aria-disabled": o,
        target: w,
        children: b
      }
    );
  if (l)
    return /* @__PURE__ */ e(
      "div",
      {
        className: `${t.buttonContainer} ${d} ${(r == null ? void 0 : r.buttonContainer) ?? ""} ${o ? t.disabled : ""}`,
        "aria-disabled": o,
        onClick: o ? void 0 : l,
        children: b
      }
    );
};
export {
  x as SlidingButton,
  v as SlidingButtonType
};
